import { Component, OnInit } from '@angular/core';
import { event } from 'jquery';
import { ApiService } from '../../../../../shared/services/api.service';
import { ActivatedRoute, Router } from '@angular/router';
import { Subscription, catchError, of } from 'rxjs';
import { API_ENDPOINTS } from '../../../../../shared/utils/const';
import { FormBuilder, FormControl, FormGroup, Validators } from '@angular/forms';
import { ToastrService } from 'ngx-toastr';
import { CommonService } from '../../../../../shared/services/common.service';
import { MatDialog } from '@angular/material/dialog';
import { PreviewfileComponent } from '../../../previewfile/previewfile.component';

@Component({
  selector: 'app-mssidcdashboard',
  templateUrl: './mssidcdashboard.component.html',
  styleUrl: './mssidcdashboard.component.css'
})


export class MssidcdashboardComponent implements OnInit {
  totalUsers = 1500;
  totalOrders = 320;
  revenue = 1480000;
  newSignups = 50;
  totalproposal = 0;
  totalMSME = 0;
  totalIA = 0;
  totalProposal = 0;
  submittedProposal = 0;
  approvedProposal = 0;
  rejectedProposal = 0;
  rejectedForQueryProposal = 0;
  totalEvents = 0
  completedEvents = 0;
  upcomingEvents = 0;
  cancelledEvents = 0;
  postponedEvents = 0;
  totalGrievances = 0;
  disposedGrievances = 0;
  pendingGrievances = 0;
  rejectedGrievances = 0;

  
  totalRegistered: number = 0;
  pendingMSMEVerification: number = 0;
  approvedMSMERegistration: number = 0;
  rejectedMSMERegistration: number = 0;
  rejectedForQueryMSME: number = 0;

  interventionData: {
    Intervention: string;
    TotalWorkshops: number;
    TotalParticipants: number;
    Components: {
      Component: string;
      Workshops: number;
      Participants: number;
    }[];
  }[] = [];

  userType: string | null = null;
    userTypechk = sessionStorage.getItem('UserType');
  filePath: string = '';
  fileName: string = '';


  private manualFileMap = {
    MSME: {
      path: 'Images\\UserManual\\MSME\\RAMP-Portal-UserManul-For-V1-MSME.pdf',
      name: 'RAMP-Portal-UserManul-For-V1-MSME.pdf'
    },
    IA: {
      path: 'Images\\UserManual\\IA\\RAMP-Portal-UserManul-For-V1-IA.pdf',
      name: 'RAMP-Portal-UserManul-For-V1-IA.pdf'
    }
  };

  name = sessionStorage.getItem('name');
  msMeUserName = sessionStorage.getItem('msMeUserName');
  isProfileCompleted = sessionStorage.getItem('isProfileCompleted')==='true'? true: false;
  loggedInUserName = sessionStorage.getItem('name');

  constructor(private formBuilder: FormBuilder, private apiService: ApiService, private route: ActivatedRoute, private toastr: ToastrService, private router: Router,
    public commonService: CommonService, private dialog: MatDialog) {

  }

      isMSMEUser: boolean = false;
  isIAUser: boolean = false;
  isMSSIDCUser: boolean = false;
  isDICUser: boolean = false;
  CheckUserType() {
    if (this.userTypechk === 'MSSIDC') {
      this.isMSSIDCUser = true;
    }
    else if (this.userTypechk === 'MSME') {
      this.isMSMEUser = true;
    }
    else if (this.userTypechk === 'IA') {
      this.isIAUser = true;
    }
    else if (this.userTypechk === 'DIC') {
      this.isDICUser = true;
    }
    else {
      this.isMSMEUser  = false;
      this.isIAUser =false;
      this.isMSSIDCUser = false;
      this.isDICUser= false;
    }
  }

  ngOnInit(): void {
    this.LoadDetails();
    this.route.paramMap.subscribe(params => {
      const menuId = params.get('id');
      //console.log('Came from menu with ID:', menuId);

      this.userType = sessionStorage.getItem('UserType')?.toUpperCase() || null;
      if (menuId === 'IA' || menuId === 'MSME') {
        this.userType = menuId;
        this.viewManual(this.userType as 'MSME' | 'IA');
      }
    });
  }

  viewManual(manualType: 'MSME' | 'IA') {
    const manual = this.manualFileMap[manualType];

    if (manual) {
      this.filePath = manual.path;
      this.fileName = manual.name;

      this.apiService.getFilePreview(this.filePath).subscribe({
        next: (fileUrl) => {
          const dialogRef = this.dialog.open(PreviewfileComponent, {
            width: '1200px',
            height: '80%',
            data: {
              fileUrl,
              fileName: this.fileName
            }
          });
          dialogRef.afterClosed().subscribe(() => {
            this.router.navigate(['/mssidcdashboard']);
          });
        },
        error: (err) => {
          console.error('Error loading file preview:', err);
        }
      });
    } else {
      console.warn('Manual not found for type:', manualType);
    }
  }

  CardRedirection(event: any) {
    const buttonId = (event.currentTarget as HTMLElement).id;

    switch (buttonId) {
      case 'btnMSME':
        this.commonService.searchText = '';
        this.router.navigate(['/msmeverification']);
        break;
      case 'btnPending':
        this.commonService.searchText = 'pending';
        this.router.navigate(['/msmeverification']);
        break;
      case 'btnApproved':
        this.commonService.searchText = 'approved';
        this.router.navigate(['/msmeverification']);
        break;
      case 'btnRejectedQuery':
        this.commonService.searchText = 'rejected for query';
        this.router.navigate(['/msmeverification']);
        break;
      case 'btnRejected':
        this.commonService.searchText = 'rejected';
        this.router.navigate(['/msmeverification']);
        break
      case 'btnIA':
        this.router.navigate(['/registeredialist']);
        break;
      case 'btnProposal':
        this.commonService.searchText = '';
        this.router.navigate(['/proposalverification']);
        break;
      case 'btnSubmittedProposal':
        this.commonService.searchText = 'pending';
        this.router.navigate(['/proposalverification']);
        break;
      case 'btnApprovedProposal':
        this.commonService.searchText = 'approved';
        this.router.navigate(['/proposalverification']);
        break;
      case 'btnRejectedProposal':
        this.commonService.searchText = 'rejected';
        this.router.navigate(['/proposalverification']);
        break;
      case 'btnRejectedForQueryProposal':
        this.commonService.searchText = 'rejected for query';
        this.router.navigate(['/proposalverification']);
        break;
      case 'btnTotalEvents':
        this.commonService.searchText = '';
        this.router.navigate(['/viewallevents']);
        break;
      case 'btnCompletedEvents':
        this.commonService.searchText = 'completed';
        this.router.navigate(['/viewallevents']);
        break;
      case 'btnUpcomingEvents':
        this.commonService.searchText = 'pending';
        this.router.navigate(['/viewallevents']);
        break;
      case 'btnCancelledEvents':
        this.commonService.searchText = 'cancel';
        this.router.navigate(['/viewallevents']);
        break;
      case 'btnPostponedEvents':
        this.commonService.searchText = 'postpone';
        this.router.navigate(['/viewallevents']);
        break;
      case 'btnTotalGrievances':
        this.commonService.searchText = '';
        this.router.navigate(['/mssidcGrievanceDashboard']);
        break;
      case 'btnDisposedGrievances':
        this.commonService.searchText = 'Disposed';
        this.router.navigate(['/mssidcGrievanceDashboard']);
        break;
      case 'btnPendingGrievances':
        this.commonService.searchText = 'Pending';
        this.router.navigate(['/mssidcGrievanceDashboard']);
        break;
      case 'btnRejectedGrievances':
        this.commonService.searchText = 'Rejected';
        this.router.navigate(['/mssidcGrievanceDashboard']);
        break;
      default:
        window.location.reload();
        break;
    }
  }


  LoadDetails() {

    const filters = {
      fromDate: '',        // Format as 'YYYY-MM-DD' if needed
      toDate: '',            // Format as 'YYYY-MM-DD' if needed
      districtCode: '',
      intervention: '',
      component: '',
      industryAssociationUserId:''
    };

    this.apiService.getRequest(API_ENDPOINTS.MSSIDC.GETTOTALCOUNT, filters).subscribe(
      result => {
        if (result.status) {
         
            const dashboard = result.namedDataSets.DashboardCounts[0];

            this.totalMSME = dashboard.TotalMSME;
            this.pendingMSMEVerification = dashboard.PendingMSMECount;
            this.approvedMSMERegistration = dashboard.ApprovedMSMECount;
            this.rejectedMSMERegistration = dashboard.RejectedMSMECount;
            this.rejectedForQueryMSME = dashboard.RejectedForQueryMSMECount;

            this.totalIA = dashboard.TotalIA;

            this.totalProposal = dashboard.TotalProposal;
            this.submittedProposal = dashboard.SubmittedProposal;
            this.approvedProposal = dashboard.ApprovedProposal;
            this.rejectedProposal = dashboard.RejectedProposal;
            this.rejectedForQueryProposal = dashboard.RejectedForQueryProposal;

            this.totalEvents = dashboard.TotalEvents;
            this.completedEvents = dashboard.CompletedEvents;
            this.upcomingEvents = dashboard.PendingEvents;
            this.cancelledEvents = dashboard.CancelledEvents;
            this.postponedEvents = dashboard.PostponedEvents;
            this.totalproposal = dashboard.TotalProposalCount;

            this.totalGrievances = dashboard.TotalGrievances;
            this.disposedGrievances = dashboard.DisposedGrievances;
            this.pendingGrievances = dashboard.PendingGrievances;
            this.rejectedGrievances = dashboard.RejectedGrievances;

        }
      }
    )

    
  }

}
